import { render, staticRenderFns } from "./SignatureBar.vue?vue&type=template&id=11974e96&scoped=true&"
import script from "./SignatureBar.vue?vue&type=script&lang=js&"
export * from "./SignatureBar.vue?vue&type=script&lang=js&"
import style0 from "./SignatureBar.vue?vue&type=style&index=0&id=11974e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11974e96",
  null
  
)

export default component.exports